<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
  <p class="text-load">&nbsp;&nbsp; Loading...</p>
</div>

<div class="breadcrumb-bar">
  <div class="breadcrumb">
    <a class="breadcrumb-link" [routerLink]="['/issue-management']">Issue Management</a>
    <span class="breadcrumb-sep" aria-hidden="true"></span>
    <span class="breadcrumb-current">{{ issueId }}</span>
  </div>
</div>

<main class="main-content">

  <!-- ─── Review Summary Banner ─── -->
  <div class="summary-panel">
    <div class="summary-col">
      <div class="summary-row">
        <span class="summary-label">Review ID</span>
        <span class="summary-value summary-value--strong">{{ reviewSummary.reviewId }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Review Name</span>
        <span class="summary-value">{{ reviewSummary.reviewName }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Client Name</span>
        <span class="summary-value">{{ reviewSummary.clientName }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Market</span>
        <span class="summary-value">{{ reviewSummary.market }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Market Unit</span>
        <span class="summary-value">{{ reviewSummary.marketUnit }}</span>
      </div>
    </div>

    <div class="summary-col">
      <div class="summary-row">
        <span class="summary-label">Location to be Reviewed</span>
        <span class="summary-value">{{ reviewSummary.locationToBeReviewed }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Country</span>
        <span class="summary-value">{{ reviewSummary.country }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Proposed Month</span>
        <span class="summary-value">{{ reviewSummary.proposedMonth }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Plan Fieldwork Start Date</span>
        <span class="summary-value">{{ reviewSummary.ScheduleFieldworkStartDate | date:'dd-MMM-yyyy' }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Plan Fieldwork End Date</span>
        <span class="summary-value">{{ reviewSummary.ScheduleFieldworkEndDate | date:'dd-MMM-yyyy' }}</span>
      </div>
    </div>

    <div class="summary-col">
      <div class="summary-row">
        <span class="summary-label">R&amp;C Reviewer</span>
        <span class="summary-value">{{ reviewSummary.rcReviewer }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">R&amp;C Supervisor</span>
        <span class="summary-value">{{ reviewSummary.rcSupervisor }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">R&amp;C Manager</span>
        <span class="summary-value">{{ reviewSummary.rcManager }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Status of Review</span>
        <span class="summary-value summary-value--strong">{{ reviewSummary.statusOfReview }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Single/Multiple Location</span>
        <span class="summary-value">{{ reviewSummary.singleMultipleLocation }}</span>
      </div>
    </div>
  </div>

  <!-- ─── Issue Form Card ─── -->
  <div class="issue-card">

    <div class="issue-id-heading">
      <span class="issue-id-text">Issue ID: <span class="issue-id-value">{{ issueId }}</span></span>
      @if (isEditMode) {
        <div class="issue-header-actions">
          @if (showRoutingNote) {
            <span class="routing-note">No Secondary Supervisor assigned. Approval routed to R&amp;C Manager.</span>
          }
          <button type="button" class="btn-header-cancel" (click)="cancel()">Cancel</button>
          @if (canApproveReject) {
            <button type="button" class="btn-reject" (click)="reject()">
              <span class="material-symbols-outlined btn-header-icon">close</span>
              Reject
            </button>
            <button type="button" class="btn-approve" (click)="approve()">
              <span class="material-symbols-outlined btn-header-icon">check</span>
              Approve
            </button>
          }
        </div>
      }
    </div>

    @if (isEditMode) {
    <!-- ═══ Edit layout: 4 columns with center vertical divider (matches mockup) ═══ -->
    <div class="edit-layout" [title]="isApprovedReadOnly ? 'All issue fields are read-only once approved by Supervisor' : ''">

      <!-- Left half: Column 1 + Column 2 -->
      <div class="edit-half">

        <!-- Column 1 -->
        <div class="edit-col">
          <div class="field-group">
            <label class="field-label">Issue Title</label>
            <div class="field-input">{{ issue.issueTitle }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Issue Rating</label>
            <div class="field-input field-rating">
              @if (issue.issueRating) {
                <span class="rating-badge" [class]="getRatingClass(issue.issueRating)">{{ issue.issueRating }}</span>
              }
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">Issue Status</label>
            <div class="field-input">{{ issue.issueStatus }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Accenture Operation Service Line</label>
            <div class="field-input field-tags-input">
              @for (sl of issue.serviceLine; track sl) {
                <span class="tag">{{ sl }} <span class="tag-x">&#x2715;</span></span>
              }
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">Identification Date</label>
            <div class="field-input">{{ issue.identificationDate | dateFormat }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Recommendation</label>
            <div class="field-input field-textarea">{{ issue.recommendation }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">RepLetter Conflict</label>
            <div class="field-input">{{ issue.repLetterConflict }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">RepLetter Questions with Conflict</label>
            <div class="field-input field-tags-input">
              @for (q of issue.repLetterQuestionsWithConflict; track q) {
                <span class="tag">{{ q }} <span class="tag-x">&#x2715;</span></span>
              }
            </div>
          </div>
        </div>

        <!-- Column 2 -->
        <div class="edit-col">
          <div class="field-group">
            <label class="field-label">Review Objective</label>
            <div class="field-input">{{ issue.reviewObjective }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Issue Description</label>
            <div class="field-input field-textarea">{{ issue.issueDescription }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Location Reviewed and Impacted?</label>
            <div class="field-input field-tags-input">
              @for (loc of issue.locationReviewedAndImpacted; track loc) {
                <span class="tag">{{ loc }} <span class="tag-x">&#x2715;</span></span>
              }
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">Action Required by</label>
            <div class="field-input">{{ issue.actionRequiredBy }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Broad Issue Category (L1)</label>
            <div class="field-input">{{ issue.broadIssueCategoryL1 }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Detailed Issue Category (L2)</label>
            <div class="field-input">{{ issue.detailedIssueCategoryL2 }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Risk Statement (L3)</label>
            <div class="field-input">{{ issue.riskStatementL3 }}</div>
          </div>
        </div>

      </div>

      <!-- Right half: Column 3 + Column 4 (center vertical divider on this half) -->
      <div class="edit-half edit-half--right">

        <!-- Column 3 -->
        <div class="edit-col">
          <div class="field-group">
            <label class="field-label">Report Status</label>
            <div class="field-input">{{ issue.reportStatus }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Issue Close Due Date</label>
            <div class="field-input">{{ issueCloseDueDate | dateFormat }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">R&amp;C Comments</label>
            <div class="field-input field-textarea">{{ issue.rcComments }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">Actual Date for Issue Closure</label>
            <div class="field-input">{{ issue.actualDateForIssueClosure | dateFormat }}</div>
          </div>
        </div>

        <!-- Column 4 -->
        <div class="edit-col">
          <div class="field-group">
            <label class="field-label">R&amp;C Reviewer</label>
            <div class="field-input">{{ reviewSummary.rcReviewer }}{{ reviewSummary.secondaryRcReviewer ? ', ' + reviewSummary.secondaryRcReviewer : '' }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">R&amp;C Supervisor</label>
            <div class="field-input">{{ reviewSummary.rcSupervisor }}{{ reviewSummary.secondaryRcSupervisor ? ', ' + reviewSummary.secondaryRcSupervisor : '' }}</div>
          </div>
          <div class="field-group">
            <label class="field-label">R&amp;C Manager</label>
            <div class="field-input">{{ reviewSummary.rcManager }}{{ reviewSummary.secondaryRcManager ? ', ' + reviewSummary.secondaryRcManager : '' }}</div>
          </div>
          <div style="display:flex; gap:20px;">
            <div class="field-group" style="flex:1;">
              <label class="field-label">{{ isGoLive ? 'Is this Issue from Go-Live?' : 'Is this Issue From?' }}</label>
              <div class="field-input">{{ issue.isThisIssueFrom }}</div>
            </div>
            <div class="field-group" style="flex:1;">
              <label class="field-label">Legacy Issue Number (AuditBoard Issue ID)</label>
              <div class="field-input">{{ issue.legacyIssueNumber }}</div>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">Subscribers/Notify</label>
            <div class="field-input field-tags-input">
              @for (sub of issue.subscribers; track sub) {
                <span class="tag">{{ sub }} <span class="tag-x">&#x2715;</span></span>
              }
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">Upload File</label>
            @if (issue.uploadedDocuments.length > 0) {
              <div class="upload-doc-area">
                <div class="upload-doc-trigger">
                  <span class="material-symbols-outlined upload-doc-icon">attach_file</span>
                  <span class="upload-doc-label">Attach Document</span>
                </div>
                @for (doc of issue.uploadedDocuments; track doc.documentId) {
                  <div class="upload-doc-item">
                    <span class="doc-filename doc-filename--link" (click)="downloadDocument(doc)">{{ doc.fileName }}</span>
                  </div>
                }
              </div>
            } @else {
              <div class="field-upload">
                <span class="material-symbols-outlined upload-icon">attach_file</span>
                <span class="upload-text">Upload Document</span>
              </div>
            }
          </div>
        </div>

      </div>

    </div>
    } @else {
    <div [title]="isApprovedReadOnly ? 'All issue fields are read-only once approved by Supervisor' : ''">
    <!-- Row 1: Issue Title | Issue Description | R&C Reviewer -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">Issue Title</label>
        <div class="field-input">{{ issue.issueTitle }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Issue Description</label>
        <div class="field-input field-textarea">{{ issue.issueDescription }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">R&amp;C Reviewer</label>
        <div class="field-input">{{ reviewSummary.rcReviewer }}{{ reviewSummary.secondaryRcReviewer ? ', ' + reviewSummary.secondaryRcReviewer : '' }}</div>
      </div>
    </div>

    <!-- Row 2: R&C Supervisor | R&C Manager | Identification Date -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">R&amp;C Supervisor</label>
        <div class="field-input">{{ reviewSummary.rcSupervisor }}{{ reviewSummary.secondaryRcSupervisor ? ', ' + reviewSummary.secondaryRcSupervisor : '' }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">R&amp;C Manager</label>
        <div class="field-input">{{ reviewSummary.rcManager }}{{ reviewSummary.secondaryRcManager ? ', ' + reviewSummary.secondaryRcManager : '' }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Identification Date</label>
        <div class="field-input">{{ issue.identificationDate | dateFormat }}</div>
      </div>
    </div>

    <!-- Row 3: Subscribers | Upload File | R&C Comments -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">Subscribers/Notify</label>
        <div class="field-input field-placeholder">Subscribers/Notify</div>
        <div class="tags-row">
          @for (sub of issue.subscribers; track sub) {
            <span class="tag">{{ sub }} <span class="tag-x">&#x2715;</span></span>
          }
        </div>
      </div>
      <div class="field-group">
        <label class="field-label">Upload File</label>
        @if (issue.uploadedDocuments.length > 0) {
          <div class="upload-doc-area">
            <div class="upload-doc-trigger">
              <span class="material-symbols-outlined upload-doc-icon">attach_file</span>
              <span class="upload-doc-label">Attach Document</span>
            </div>
            @for (doc of issue.uploadedDocuments; track doc.documentId) {
              <div class="upload-doc-item">
                <span class="doc-filename doc-filename--link" (click)="downloadDocument(doc)">{{ doc.fileName }}</span>
                @if (isEditMode && !isDraft) {
                  <span class="material-symbols-outlined doc-delete-icon">delete</span>
                }
              </div>
            }
          </div>
        } @else {
          <div class="field-upload">
            <span class="material-symbols-outlined upload-icon">attach_file</span>
            <span class="upload-text">Upload Document</span>
          </div>
        }
      </div>
      <div class="field-group">
        <label class="field-label">R&amp;C Comments</label>
        <div class="field-input field-textarea">{{ issue.rcComments }}</div>
      </div>
    </div>

    <!-- Row 4: Action Required by | Issue Rating | Issue Status -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">Action Required by</label>
        <div class="field-input">{{ issue.actionRequiredBy }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Issue Rating</label>
        <div class="field-input field-rating">
          @if (issue.issueRating) {
            <span class="rating-badge" [class]="getRatingClass(issue.issueRating)">{{ issue.issueRating }}</span>
          }
        </div>
      </div>
      <div class="field-group">
        <label class="field-label">Issue Status</label>
        <div class="field-input">{{ issue.issueStatus }}</div>
      </div>
    </div>

    <!-- Row 5: Review Objective | Recommendation | Location Reviewed and Impacted -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">Review Objective</label>
        <div class="field-input field-textarea">{{ issue.reviewObjective }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Recommendation</label>
        <div class="field-input field-textarea">{{ issue.recommendation }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Location Reviewed and Impacted?</label>
        <div class="field-input field-tags-input">
          @for (loc of issue.locationReviewedAndImpacted; track loc) {
            <span class="tag">{{ loc }} <span class="tag-x">&#x2715;</span></span>
          }
        </div>
      </div>
    </div>

    <div class="form-divider"></div>

    <!-- Row 6: Broad Issue Category | Detailed Issue Category | Risk Statement -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">Broad Issue Category (L1)</label>
        <div class="field-input">{{ issue.broadIssueCategoryL1 }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Detailed Issue Category (L2)</label>
        <div class="field-input">{{ issue.detailedIssueCategoryL2 }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Risk Statement (L3)</label>
        <div class="field-input">{{ issue.riskStatementL3 }}</div>
      </div>
    </div>

    <!-- Row 7: RepLetter Conflict | RepLetter Questions with Conflict | Service Line -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">RepLetter Conflict</label>
        <div class="field-input">{{ issue.repLetterConflict }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">RepLetter Questions with Conflict</label>
        <div class="field-input field-placeholder">Question</div>
        <div class="tags-row">
          @for (q of issue.repLetterQuestionsWithConflict; track q) {
            <span class="tag">{{ q }} <span class="tag-x">&#x2715;</span></span>
          }
        </div>
      </div>
      <div class="field-group">
        <label class="field-label">Accenture Operation Service Line</label>
        <div class="field-input field-tags-input">
          @for (sl of issue.serviceLine; track sl) {
            <span class="tag">{{ sl }} <span class="tag-x">&#x2715;</span></span>
          }
        </div>
      </div>
    </div>

    <!-- Row 8: Max Target Date | Actual Date for Issue Closure | Report Status -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">Issue Close Due Date</label>
        <div class="field-input">{{ issueCloseDueDate | dateFormat }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Actual Date for Issue Closure</label>
        <div class="field-input">{{ issue.actualDateForIssueClosure | dateFormat }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Report Status</label>
        <div class="field-input">{{ issue.reportStatus }}</div>
      </div>
    </div>

    <!-- Row 9: Is this issue from + Legacy Issue Number (GoLive only) -->
    <div class="form-grid">
      <div class="field-group">
        <label class="field-label">{{ isGoLive ? 'Is this Issue from Go-Live?' : 'Is this Issue From?' }}</label>
        <div class="field-input">{{ issue.isThisIssueFrom }}</div>
      </div>
      <div class="field-group">
        <label class="field-label">Legacy Issue Number (AuditBoard Issue ID)</label>
        <div class="field-input">{{ issue.legacyIssueNumber }}</div>
      </div>
    </div>
    </div>
    }

    <!-- ─── Linked Action Plan ─── -->
    <div class="linked-ap-section">

      <!-- Gray title bar -->
      <div class="linked-ap-title-bar">
        <h3 class="linked-ap-title">Linked Action Plan</h3>
      </div>

      <!-- Body: mirrors accordion-body padding -->
      <div class="linked-ap-body">

        <!-- Search row -->
        <div class="linked-ap-search-row">
          <div class="linked-ap-search-wrapper">
            <input type="text" class="linked-ap-search-input" placeholder="Search Action Plan"
              [(ngModel)]="actionPlanSearch" />
            <span class="linked-ap-search-icon" aria-hidden="true">
              <mat-icon>search</mat-icon>
            </span>
          </div>
        </div>

        <!-- Table wrapper — edge-to-edge within body padding, matching ap-table-wrapper -->
        <div class="linked-ap-table-wrapper">
          <table class="linked-ap-table">
            <thead>
              <tr>
                <th class="th-ap-id">Action Plan ID</th>
                <th class="th-ap-desc">Action Plan Description</th>
                <th class="th-ap-owner">Owner</th>
                <th>Target Date</th>
                <th class="th-ap-status">AP Status</th>
                <th class="th-action">Action</th>
              </tr>
            </thead>
            <tbody>
              @for (ap of filteredActionPlans; track ap.id) {
                @if (issue.issueRating === 'Blue' && hasSupervisorAccess ? ap.status === 'Closed-Blue Not Tracked' : true) {
                <tr>
                  <td><span class="ap-id-cell" [class.ap-id-cell--clickable]="!(hasSupervisorAccess && isInactiveStatus && !isEditMode)" (click)="!(hasSupervisorAccess && isInactiveStatus && !isEditMode) && openActionPlan(ap)">{{ ap.id }}</span></td>
                  <td class="ap-desc-cell" [title]="ap.description">{{ ap.description }}</td>
                  <td class="ap-owner-cell" [title]="ap.owner">{{ ap.owner }}</td>
                  <td>{{ ap.targetDate | dateFormat }}</td>
                  <td class="td-ap-status">{{ ap.status }}</td>
                  <td class="ap-action-cell">
                    <input type="checkbox" [(ngModel)]="ap.linked"
                      [disabled]="!fromViewIcon || !isAdmin"
                      [class.checkbox-interactive]="fromViewIcon && isAdmin"
                      (change)="onLinkedApChange()" />
                    <span class="ap-link-label">Link</span>
                  </td>
                </tr>
              }
              }
              @if (filteredActionPlans.length === 0) {
                <tr>
                  <td colspan="6" class="ap-empty">No records found</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!-- ─── Warning Message ─── -->
    <div class="warning-bar">
      <span class="material-symbols-outlined warning-icon-box">announcement</span>
      <span class="warning-text">
        If the mandatory information (<span class="warning-link warning-link--red">fields</span>) is not available in the form,
        To request to add missing information please contact admin to get added that information via
        '<span class="warning-link warning-link--blue">Request to Add information&lt;Email Id&gt;</span>',
        meanwhile you can use '<span class="warning-link warning-link--violet">Save</span>' functionality to save your form.
        E.g. The master client, Location to Be Review , is not available for you then contract admin to get it added.
      </span>
    </div>

    <!-- ─── Form Actions ─── -->
    <div class="form-actions">
      <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
      <button type="button" class="btn-update" [disabled]="!isLinkedApDirty" (click)="update()">Update</button>
    </div>

  </div>

</main>

<!-- ─── Confirm Issue Approval Popup ─── -->
@if (showApproveModal) {
<div class="approve-popup-overlay" (click)="closeApproveModal()">
  <div class="approve-popup" (click)="$event.stopPropagation()">
    <div class="approve-popup-header">
      <h2 class="approve-popup-title">Confirm Issue Approval</h2>
    </div>
    <div class="approve-popup-body">
      <p class="approve-popup-message">
        You are about to approve this Issue
        (<span class="approve-popup-issue">{{ issueId }}: {{ issue.issueTitle }}</span>).
      </p>
      <p class="approve-popup-message">This action is permanent and cannot be undone.</p>
    </div>
    <div class="approve-popup-footer">
      <button type="button" class="approve-popup-cancel" (click)="closeApproveModal()">Cancel</button>
      <button type="button" class="approve-popup-confirm" [disabled]="isSubmitting" (click)="confirmApprove()">Approve Issue</button>
    </div>
  </div>
</div>
}

<!-- ─── Confirm Request Rejection Popup ─── -->
@if (showRejectModal) {
<div class="approve-popup-overlay" (click)="closeRejectModal()">
  <div class="approve-popup reject-popup" (click)="$event.stopPropagation()">
    <div class="approve-popup-header">
      <h2 class="approve-popup-title">Confirm Request Rejection</h2>
    </div>
    <div class="reject-popup-body">
      <p class="reject-popup-message">
        You are about to reject this Request
        <span class="reject-popup-issue">{{ issueId }}: {{ issue.issueTitle }}</span>.
      </p>
      <div class="reject-reason-group">
        <label class="reject-reason-label">Reason for Rejection <span class="reject-reason-required">*</span></label>
        <textarea class="reject-reason-input" rows="4" [(ngModel)]="rejectionReason"
          placeholder="Enter reason for rejection"></textarea>
      </div>
    </div>
    <div class="reject-popup-footer">
      <button type="button" class="approve-popup-cancel" (click)="closeRejectModal()">Cancel</button>
      <button type="button" class="reject-popup-confirm" [disabled]="!rejectionReason.trim() || isSubmitting"
        (click)="confirmReject()">Reject Request, notify the user</button>
    </div>
  </div>
</div>
}

<!-- ─── Action Plan Details Read-Only Popup ─── -->
@if (selectedActionPlanId) {
  <app-action-plan-detail-popup
    [reviewId]="reviewId"
    [actionPlanId]="selectedActionPlanId"
    [isGoLive]="isGoLive"
    (close)="closeActionPlanPopup()">
  </app-action-plan-detail-popup>
}
